import { swapServicesToEmployee } from "./swapServicesToEmployee";

export type ProviderOption = {
    employee: any;
    // Why this provider can't take the appointment; null when they can
    unavailableReason: string | null;
};

const overlaps = (event: any, start: Date, end: Date) =>
    new Date(event.start) < end && new Date(event.end) > start;

const offersAnyService = (employee: any) =>
    (employee?.services ?? []).some((ms: any) => !ms?.status || ms.status === "active");

// Options for the appointment drawer's Provider dropdown. Only people who provide
// services are listed (the admin/owner only if they do), the current provider always.
// Each one is greyed out with a reason when they don't offer every service on the
// appointment or, for the day the calendar has loaded, aren't free for the whole time.
export function getProviderOptions({
    employees,
    services,
    start,
    end,
    events,
    appointmentId,
    currentEmployeeId,
    checkTime,
}: {
    employees: any[];
    services: any[];
    start: Date;
    end: Date;
    events: any[];
    appointmentId: number | undefined;
    currentEmployeeId: number | undefined;
    // false when the appointment was moved to a day the calendar hasn't loaded
    checkTime: boolean;
}): ProviderOption[] {
    return employees
        .filter((employee) => employee.id === currentEmployeeId || offersAnyService(employee))
        .map((employee) => {
            if (employee.id === currentEmployeeId) return { employee, unavailableReason: null };

            const { missing } = swapServicesToEmployee(services, employee);
            if (missing.length > 0) {
                return { employee, unavailableReason: `doesn't offer ${missing.join(", ")}` };
            }

            if (checkTime) {
                const theirs = (events ?? []).filter(
                    (e) => e.resourceId === employee.id && overlaps(e, start, end)
                );
                if (theirs.some((e) => e.type === "offtime")) {
                    return { employee, unavailableReason: "not working" };
                }
                if (theirs.some((e) => e.type === "blocked")) {
                    return { employee, unavailableReason: "blocked" };
                }
                if (theirs.some((e) => e.type === "appointment" && e.id !== appointmentId)) {
                    return { employee, unavailableReason: "busy" };
                }
            }

            return { employee, unavailableReason: null };
        });
}
